import DigitalGiveawayModal from './DigitalGiveawayModal'
import digitalGiveawayModalContainer from './digitalGiveawayModalContainer'

export default digitalGiveawayModalContainer(DigitalGiveawayModal)
